import { Organization } from '@mp/kernel/organizations/domain';

/** Identifikationsfeld einer Organisation: deutsche Beschriftung + Modellschlüssel. */
export interface OrganizationIdentifierField {
  readonly label: string;
  readonly key: Extract<keyof Organization, 'institutionCode' | 'externalId' | 'mediioCustomerId'>;
}

/**
 * Die auf der Organisationskarte gezeigten Identifikationsfelder, in derselben Reihenfolge wie in
 * System > Organisation.
 */
export const ORGANIZATION_DISPLAY_IDENTIFIER_FIELDS: ReadonlyArray<OrganizationIdentifierField> = [
  { label: 'MEDIIO Kundenkennung', key: 'mediioCustomerId' },
  { label: 'Institutionskennzeichen', key: 'institutionCode' },
  { label: 'Externe Kennung', key: 'externalId' },
];

/**
 * Die durchsuchbaren Identifikationsfelder. Bewusst enger als die Anzeigeliste — hier stehen beide
 * nebeneinander, damit die Abweichung sichtbar bleibt.
 */
export const ORGANIZATION_SEARCHABLE_IDENTIFIER_KEYS: ReadonlyArray<OrganizationIdentifierField['key']> = [
  'mediioCustomerId',
  'externalId',
];
